<template>
    <div>
		<v-dialog
			v-model="dialog"
			persistent
			width="700"
			:createAt="create"
			:fullscreen="$vuetify.breakpoint.smAndDown"
			@keydown.esc="dialog = false"
		>
            <v-card flat>
                <!-- title -->
				<div class="d-flex py-1 primary">
					<v-card-title
						class="text-uppercase text-subtitle-1 flex-grow-1 justify-center pa-0 white--text"
					>
						{{title}}	
					</v-card-title>
					<!-- close button -->
					<v-btn icon  @click="dialog=false">
						<v-icon color="white">
							mdi-close-circle-outline
						</v-icon>
					</v-btn>
				</div>
                
                <v-form ref="form">
                    <!-- radio buttons -->
                    <!-- <v-radio-group
						v-if="id === null && customersTypes.length"
						v-model="dirType"
						row
						hide-details
						@change="reset"
						class="my-1"
                    >
                        <v-radio
							v-for="(type, index) in customersTypes"
							:key="index"
							:label="type.name"
							:value="type.id"
							class="mx-auto"
							color="success" 
						/>
                    </v-radio-group> -->

                    <!-- card content -->
                    <v-card-text 
						:class="{
							'pt-2': !id,
							'pt-4': id
						}"
					>
						<v-row dense class="">
							<v-col v-if="id === null && customersTypes.length" cols="12" align-self="center">
								<v-chip-group
									v-model="dirType"
									show-arrows
									center-active
									active-class="success"
									class="d-flex justify-center pt-0"
									mandatory
									@change="reset"
								>
									<v-chip 
										v-for="(type, index) in customersTypes"
										:key="index"
										:value="type.id"
										class="rounded-xl"
									>
										{{ type.name }}
									</v-chip>
								</v-chip-group>
							</v-col>
							<v-col md="6" cols="12" align-self="end">
								<v-autocomplete
									v-model="cityId"
									:items="cities"
									item-text="name"
									item-value="id"
									:label="$t('inputs.city')"
									dense
									hide-details
									persistent-hint
									@change="getRegions()"
									outlined
									autofocus
								></v-autocomplete>
							</v-col>
							<!-- region -->
							<v-col md="6" cols="12">
								<v-autocomplete
									v-model="regionId"
									:items="regions"
									item-text="name"
									item-value="id"
									:label="!managementHierarchyRegions ? $t('inputs.region') : $t('inputs.area')"
									@change="fetchEntities"
									:rules="rules.required"
									hide-details="auto"
									:loading="regionsLoading"
									:disabled="regionsLoading || !cityId"
									outlined
									dense
								></v-autocomplete>
							</v-col>

							<!-- entity -->
							<v-col md="6" cols="12">
								<v-autocomplete
									v-model="entityId"
									:items="entities"
									item-text="name"
									item-value="id"
									:label="$t('inputs.entity-name')"
									:loading="EntitiesLoading"
									:disabled="EntitiesLoading || regionId === null"
									dense
									outlined
									hide-details="auto"
								></v-autocomplete>
							</v-col>
							
							<!-- Resident doctor -->
							<!-- v-if="dirType === 2" -->
							<v-col v-if="visitsConfig?.ResidentEmployeesNames" md="12" cols="12">
								<v-text-field
									v-model="residentDoctorNames"
									:label="$t('inputs.resident-doctors')"
									:loading="EntitiesLoading"
									:disabled="EntitiesLoading || regionId === null"
									outlined
									dense
									hide-details
								/>
							</v-col>

							<v-col
								v-if="addPrice"
								cols="12" 
								class="py-0"
							>
								<v-chip-group
									v-model="priceType"
									show-arrows
									center-active
									active-class="success"
									class="d-flex justify-center pt-0"
									mandatory
								>
									<v-chip 
										v-for="(type, index) in pricesTypes" 
										:key="index" 
										filter 
										:value="type.id"
										class="pt-0"
										:disabled="Boolean(samplesItems.length)"
									>
										{{ type.name }}
									</v-chip>
								</v-chip-group>
							</v-col>

							<!-- <v-col 
								v-if="addPrice"
								cols="12" 
								class="py-0"
							>
								<v-chip-group
									v-model.number="payment"
									show-arrows
									center-active
									active-class="success"
									class="d-flex justify-center pt-0"
									mandatory
								>
									<v-chip 
										v-for="(type, index) in paymentMethods"
										:key="index"
										:value="type.id"
										class="rounded-xl"
									>
										{{ type.name }}
									</v-chip>
								</v-chip-group>
							</v-col> -->

							<!-- table -->
							<v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12">
								<bee-handy-smart-table 
									ref="table"
									v-model="tableInputs"
									:items="samplesItems"
									:headers="headersSamples"
									:show-add-row="!loading"
									dense
									zebra
									class="my-1"
									hot-inputs
									:editable-rows="!loading"
									hide-default-footer
									@change-materialId="getPrice()"
									@change-freeSample="resetAllFieldAssociatedWithThePrice()"
									:footer-props="{
										itemsPerPageOptions: [],
										showCurrentPage: true,
										itemsPerPageText: '',
										pageText: '',
									}"
									:hide-inputs-details="true"
									@input-sellPrice="disableDiscount = true; tableInputs.priceDiscount = 0"
								>
									<template v-slot:input.materialId="{ on, attr}">
										<v-autocomplete 
											:items="myMaterials"
											item-text="name"
											item-value="id"
											v-on="on"
											v-bind="attr"
										/>
									</template>

									<template v-if="addPrice" v-slot:input.priceDiscount="{ on, attr }">
										<v-text-field 
											prefix=" %"
											v-on="on"
											v-bind="attr"
											:disabled="disableDiscount || tableInputs.freeSample"
											type="number"
											hide-spin-buttons
										/>
									</template>

									<template v-if="addPrice" v-slot:input.freeSample="{ on, attr }">
										<v-checkbox 
											v-model="tableInputs.freeSample"
											hide-details
											v-on="on"
											v-bind="attr"
										/>
									</template>

									<template v-if="addPrice" v-slot:item.freeSample="{ item }">
										<v-chip small>
											<span :class="item.freeSample === true ? 'primary--text' : 'paid-color-text'">
												{{ item.freeSample === true ? 'Free' : 'Paid' }}
											</span>
										</v-chip>
									</template>

									<template v-if="addPrice" v-slot:footer >
										<v-divider class="my-1" />
										<div 
											v-if="samplesItems.length !== 0" 
											class="d-flex justify-center mb-1" 
										>
											<span class="font-weight-bold">
												{{ $t('inputs.total') + ': ' }}
											</span>
											<span class="font-weight-bold success--text mx-1"> 
												{{ total }}
											</span>
										</div>
									</template>

									<!-- action column -->
									<template v-slot:item.action="{ index }">
										<div class="d-flex">  
											<v-btn
												icon
												small
												color="edit-color"
												@click="() => {
													$refs.table.activeEditForRow(index);
													editRowIndex = index;
													isEdit = true
												}"
											>
												<v-icon>
													mdi-pencil
												</v-icon>
											</v-btn>  

											<v-btn
												icon
												small
												color="alert-color"
												@click="deleteRow({ index })"
											>
												<v-icon>
													mdi-delete
												</v-icon>
											</v-btn>
										</div>
									</template>

									<!-- no-input action -->
									<template v-slot:no-input.action>
										<div class="d-flex justify-center">
											<v-btn
												icon
												small
												color="success"
												:disabled="loading"
												@click="isEdit ? editItem() : addItem()"
											>
												<v-icon>
													mdi-check-circle-outline
												</v-icon>
											</v-btn>
										</div>
									</template>
								</bee-handy-smart-table>
							</v-col>
							
							<!-- card -->
							<v-col v-else cols="12">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<v-icon class="me-2">mdi-pill</v-icon>
										<span class="text-body-1">{{$t('Visits.samples')}}</span>
									</div>

									<v-btn text @click="addSample">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>
								
								<!-- sample card -->
								<v-card v-if="samples.length > 0">
									<v-card-text>
										<v-row
											dense
											v-for="sample in samples.map(c => c.data)"
											:key="sample.id"
											class="align-center"
										>
											<!-- sample -->
											<v-col :cols="!addPrice ? 7 : 8">
												<v-autocomplete
													v-model="sample.materialId"
													:items="myMaterials"
													item-text="name"
													item-value="id"
													:label="$t('inputs.sample')"
													dense
													hide-details
													@change="getPrice(sample, sample.id)"
												></v-autocomplete>
												<!-- sample.sellPrice  = myMaterials.find(c => c.id === sample.materialId) ? myMaterials.find(c => c.id === sample.materialId).materialPrice : 0 -->
											</v-col>

											<!-- amount -->
											<v-col :cols="!addPrice && samples.length > 1 ? 3 : addPrice ? 4 : 5">
												<v-text-field
													v-model.number="sample.amount"
													:label="$t('inputs.amount')"
													type="number"
													min="0"
													dense
													hide-spin-buttons
													hide-details
												></v-text-field>
											</v-col>

											<!-- <v-col v-if="addPrice" cols="6">
												<v-autocomplete 	
													v-model="sample.priceType"
													:items="pricesTypes"
													item-value="id"
													item-text="name"
													dense
													hide-details
													:label="$t('inputs.price-type')"
										
													:disabled="sample.freeSample"
												/>

											</v-col> -->

											<v-col v-if="addPrice" cols="4" class="mt-1">
												<v-text-field
													v-model.number="sample.sellPrice"
													:label="$t('inputs.price')"
													type="number"
													min="0"
													dense
													hide-spin-buttons
													hide-details
													@input="customPrice = true; sample.priceDiscount = null; sample.priceType = null"
													:disabled="sample.freeSample"
													:rules="
														myMaterials.find(c => c.id === sample.materialId)?.prices.length && 
														myMaterials.find(c => c.id === sample.materialId)?.prices.find(c => c.priceId === priceType)?.price !== 0 && 
														myMaterials.find(c => c.id === sample.materialId)?.prices.find(c => c.priceId === priceType)?.priceDiscount > 0 
															? [val => {
																const material = myMaterials.find(c => c.id === sample.materialId)
																const priceForPriceType = material.prices.find(c => c.priceId === priceType)?.price
																const discount = material?.prices.find(c => c.priceId === priceType)?.priceDiscount / 100 
																return (priceForPriceType - (priceForPriceType * discount)) <= Number(val) && priceForPriceType >= Number(val)
															}] 
															: []"
												></v-text-field>
											</v-col>

											<v-col v-if="enableDiscount" cols="4" class="mt-1">
												<v-text-field
													v-model.number="sample.priceDiscount"
													:label="$t('inputs.discount-rate')"
													type="number"
													min="0"
													dense
													hide-spin-buttons
													hide-details
													prefix="%"
													:disabled="
														sample.freeSample ||
														(
															sample.freeSample &&
															sample.sellPrice !== myMaterials.find(c => c.id === sample.materialId)?.prices.find(c => c.priceId === priceType)?.price
															&& !sample.priceDiscount
														)
													"
													:rules="[val => val <= (myMaterials.find(c => c.id === sample.materialId)?.prices.find(c => c.priceId === priceType)?.priceDiscount) || val === 0]"
													@change="(() => {
														if(
															myMaterials.find(c => c.id === sample.materialId) 
															&& 
															myMaterials.find(c => c.id === sample.materialId).prices.length !== 0
															&&
															myMaterials.find(c => c.id === sample.materialId).prices.find(c => c.priceId === priceType)
														) {
															const priceFromApiByType = myMaterials.find(c => c.id === sample.materialId).prices.find(c => c.priceId === priceType).price
															return sample.sellPrice = priceFromApiByType - priceFromApiByType * (sample.priceDiscount / 100)
														}
														
													})"
												></v-text-field>
											</v-col>

											<v-col v-if="addPrice" cols="3" class="py-3">
												<v-checkbox 
													v-model="sample.freeSample"
													dense
													hide-details
													:true-value="true"
													@click="(() => {
														if(sample.freeSample) {
															sample.priceType = null
															sample.sellPrice = 0
															sample.priceDiscount = 0
														}
													})"
													:label="$t('inputs.free')"
												/>
											</v-col>

											<!-- remove button -->
											<v-col v-if="samples.length > 1" cols="2" class="pa-0">
												<v-btn text small @click="removeSample(sample.id)">
													<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
												</v-btn>
											</v-col>	
										</v-row>
									</v-card-text>

									<div v-if="id" class="text-center pb-2">
										<span class="font-weight-bold">
											{{ $t('inputs.total') + ': ' }}
										</span>
										<span class="font-weight-bold success--text mx-1"> 
											{{ total }}
										</span>
									</div>
								</v-card>
							</v-col>

							<v-col cols="6" v-if="addPrice">
								<v-text-field
									v-model.number="amountReceived"
									:label="$t('inputs.amount-received')"
									type="number"
									min="0"
									dense
									hide-spin-buttons
									hide-details
									outlined
								/>
							</v-col>

							<!-- unavailable materialIds -->
							<v-col md="6" cols="12" v-if="visitsConfig?.UnavailableMaterials">
								<v-autocomplete
									v-model="unavailableMaterialIds"
									:items="myMaterials"
									item-text="name"
									item-value="id"
									:label="$t('inputs.unavailable-products')"
									multiple
									hide-details="auto"
									dense
									outlined		
								>
									<template v-slot:selection="{ item, index }">
										<span v-if="index === 0" class="me-1">{{ item.name }}</span>
										<span
											v-if="index === 1"
											class="grey--text text-caption"
										>
											(+{{ unavailableMaterialIds.length - 1 }} others)
										</span>
									</template>
								</v-autocomplete>
							</v-col>

							<!-- competitors -->
							<v-col md="12" cols="12" v-if="visitsConfig?.CompetetiveSample">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<v-icon class="me-2">mdi-trending-up</v-icon>
										<span class="text-body-1">{{ $t('inputs.competitors') }}</span>
									</div>

									<v-btn text @click="addCompetitor">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>

								<!-- Competitor card -->
								<v-card v-if="competitors.length > 0" class="">
									<v-card-text 
										class="d-flex"
										:class="{
											'flex-wrap': competitors.length > 3
										}"
									>
										<v-row
											v-for="(competitor, index) in competitors"
											:key="index"
											class="align-center mt-0"
										>
											<!-- competitor -->
											<v-col cols="9" class="px-1">
												<v-text-field
													v-model="competitor.value"
													label="Competitor"
													dense
													hide-details
													required
													outlined
												></v-text-field>
											</v-col>

											<!-- remove button -->
											<v-col cols="2" class="pa-0">
												<v-btn
													text
													small
													@click="removeCompetitor(competitor.id)"
													class="display-flex justify-start px-0"
												>
													<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>

							<!-- coreMessage -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="coreMessage"
									:label="$t('inputs.core-message')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- durationInMinutes -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model.number="durationInMinutes"
									:label="$t('inputs.duration-in-minutes')"
									type="number"
									hide-spin-buttons
									suffix="minutes"
									min="0"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- other samples -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="otherSamples"
									:label="$t('inputs.other-samples')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- visitNotes -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="visitNotes"
									:label="$t('inputs.visit-notes')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- objection -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="objection"
									:label="$t('inputs.objections')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- nextCall -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="nextCall"
									:label="$t('inputs.next-call')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>

							<!-- center notes -->
							<v-col cols="12" v-if="visitsConfig?.NextVisitNotes">
								<v-text-field
									v-model="centerNotes"
									:label="$t('inputs.notes')"
									hide-details
									dense
									outlined
								></v-text-field>
							</v-col>
						</v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn 
							color="success" 
							text 
							type="submit" 
							:loading="loading" 
							:disabled="loading" 
							@click="submit"
						>
                            {{$t('save')}}
                        </v-btn>
                      <v-btn
                        	color="grey darken-1"
                        	text
                        	@click="dialog = false"
                        >
                            {{$t('close')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import rules from '../validation rules'
import { mapState, mapGetters } from 'vuex'
import { managementHierarchyRegions, addPrice, enableDiscount } from '@/configs/global.config'
import { paymentMethods } from '@/helpers/enums'
import moment from 'moment'
export default {
	props: {
		create: {
			type: String,
		}
	},
	data() {
		return {
			// helpers
			entities: [],
			id: null,
			dialog: false,

			title: null,

			loading: false,
			EntitiesLoading: false,
			regionsLoading: false,
			rules,
            
			sampleCounter: 1,
			competitorCounter: 0,

			// data
			dirType: null,
			regionId: null,
			cityId: null,
			entityId: null,
			residentDoctorNames: null,
			samples: [{
				id: 1,
				data: {
					id: 1,
					materialId: null,
					amount: null,
					sellPrice: 0,
					priceDiscount: null,
					priceType: null
				}
			}],
			coreMessage: null,
			durationInMinutes: null,
			otherSamples: null,
			visitNotes: null,
			objection: null,
			nextCall: null,
			unavailableMaterialIds: [],
			competitors: [],
			centerNotes: null,
			managementHierarchyRegions,
			customPrice: false,
			addPrice,
			enableDiscount,
			samplesItems: [],
			tableInputs: {
				priceDiscount: 0
			},
			isEdit: false,
			editRowIndex: null,
			priceType: null,
			disableDiscount: false,
			amountReceived: 0,
			paymentMethods,
			payment: null
		}
	},

	watch: {
		dialog (val) {
			if (val && !this.id) {
				this.dirType = this.customersTypes[0]?.id
				this.priceType = this.customersTypes.find(c => c.id === this.dirType)?.priceId
			}
		},

		dirType (val) {
			this.priceType = this.customersTypes.find(c => c.id === this.dirType)?.priceId
		}
	},

	methods: {
		reset() {
			if (this.$refs.form) this.$refs.form.resetValidation();

			this.id = null;
			this.sampleCounter = 1;
			this.competitorCounter = null;

			this.cityId = null;
			this.regionId = null;
			this.entityId = null;
			this.residentDoctorNames = null;
			this.samples = [{
				id: 1,
				data: {
					id: 1,
					materialId: null,
					amount: null,
					sellPrice: null,
					priceDiscount: null,
					priceType: null
				}
			}];
			this.coreMessage = null;
			this.durationInMinutes = null;
			this.otherSamples = null;
			this.visitNotes = null;
			this.objection = null;
			this.nextCall = null;
			this.unavailableMaterialIds = [];
			this.amountReceived = 0;
			this.competitors = [];
			this.centerNotes = null;
			this.day = null
			this.priceType = null
			// resetTable
			this.samplesItems = []
			if (this.$refs.table) {
				this.$nextTick(() => {
					this.$refs.table.resetInputs()
				})
			}
			this.disableDiscount = false
		},

		resetTable () {
			if (this.$refs.table) {
				this.$nextTick(() => {
					this.$refs.table.resetInputs()
				})
			} else {
				this.samples = [{
					id: 1,
					data: {
						id: 1,
						materialId: null,
						amount: null,
						sellPrice: null,
						priceDiscount: null,
						priceType: null
					}
				}];
			}
		},

		// samples
		addSample() {
			this.samples.push({
				id: ++this.sampleCounter,
				data: {
					id: this.sampleCounter,
					materialId: null,
					amount: null,
					sellPrice: null,
					priceDiscount: null,
					priceType: null,
					total: 0
				}
			})
		},

		removeSample(id) {
			const index = this.samples.findIndex(c => c.id === id);
			this.samples.splice(index, 1);
			this.samples.forEach(sample => {
				if (sample.id > index) {
					sample.id--;
				}
			})
			this.sampleCounter--;
		},
        
		// competitor
		addCompetitor() {
			this.competitors.push({
				id: this.competitorCounter++,
				value: null
			})
		},

		removeCompetitor(index) {
			this.competitors.splice(index, 1);
			this.competitors.forEach(competitor => {
				if (competitor.id > index) {
					competitor.id--;
				}
			})
			this.competitorCounter--;
		},

		// find data
		getFullMaterialName(material) {
			const details = [
				this.getMaterialFormById(material.materialFormId).name,
				material.dose,
				material.strength
			];

			return `${material.name} (${details.filter(c => c != null).join(' ')})`;
		},

		fetchEntities() {
			this.EntitiesLoading = true;
			// let type;
			// switch (this.dirType) {
			// case 0 : type = 1; break; // Doctor
			// case 1 : type = 2; break; // Pharmacy
			// case 2 : type = 0; break; // Center
			// }
			this.$store.dispatch('entities/fetchAllBrief', { 
				typeId: this.dirType, 
				regionIds: [this.regionId],
				preventStoreEntities: true
			}).then((data) => {
				this.entities = data
			}).finally(() => {
				this.EntitiesLoading = false;
			})
		},

		// dialog functions
		addVisit() {
			this.reset();
			this.dirType = null;
			this.title = this.$t('Visits.add-visit');
			this.dialog = true;
		},

		editVisit(id, day) {
			this.reset();
			this.id = id;
			this.day = day
			this.fillData();
			this.title = this.$t('edit-visit');
			this.dialog = true;
		},

		fillData() {
			this.$store.dispatch('mineVisits/fetchAllData', { day: moment().format('YYYY-MM-DD') }).then((data) => {
				const visit = data.find(c => c.id === this.id)
				// switch (visit?.entity?.entityType) {
				// 	case 0: this.dirType = 2; break;
				// 	case 1: this.dirType = 0; break;
				// 	case 2: this.dirType = 1; break;
				// }
				this.regionId = visit.entityAddresses.length ? visit?.entityAddresses[0]?.regionId : null;
				this.cityId = this.regionId ? this.getRegionAllById(this.regionId).cityId : null;
				this.getRegions();
				// new
				this.dirType = visit.entity.entityTypeId;
				this.entityId = visit.entity.id;
				this.residentDoctorNames = visit.residentDoctorNames;
				this.coreMessage = visit.coreMessage;
				this.durationInMinutes = visit.durationInMinutes;
				this.otherSamples = visit.otherSamples;
				this.visitNotes = visit.notes;
				this.objection = visit.objections;
				this.nextCall = visit.purpose;
				this.centerNotes = visit.nextVisitNotes;
				this.priceType = visit.priceTypeId
				
				visit.unavailableMaterials.forEach(materialName => {
					this.unavailableMaterialIds.push(this.getMaterialByName(materialName).id);
				})
				this.amountReceived = visit?.amountReceived;
				this.samples = [];
				if (visit.materialAmounts.length !== 0) {
					visit.materialAmounts.forEach(materialAmount => {
						this.samples.push({
							id: ++this.sampleCounter,
							data: {
								materialId: materialAmount.materialId,
								amount: materialAmount.amount,
								// new
								sellPrice: materialAmount.sellPrice,
								freeSample: materialAmount.freeSample,
								priceDiscount: materialAmount.priceDiscount,
								total: (materialAmount.amount * materialAmount.sellPrice) - (materialAmount.amount * materialAmount.sellPrice * materialAmount.priceDiscount / 100)
							}
						})
						this.samplesItems.push({
							id: ++this.sampleCounter,
							materialId: materialAmount.materialId,
							amount: materialAmount.amount,
							// new
							sellPrice: materialAmount.sellPrice,
							freeSample: materialAmount.freeSample,
							priceDiscount: materialAmount.priceDiscount ? +materialAmount.priceDiscount : 0,
							total: (materialAmount.amount * materialAmount.sellPrice) - (materialAmount.amount * materialAmount.sellPrice * materialAmount.priceDiscount / 100)
						
						})
					})
				}

				visit.competitiveSamples.forEach(sample => {
					this.competitors.push({
						id: this.competitorCounter++,
						value: null
					})
				});

				this.fetchEntities();
			})
		},

		submit() {
			this.loading = true;
			if (this.id === null) {
				this.$store.dispatch('mineVisits/create', {
					entityId: this.entityId,
					coreMessage: this.coreMessage,
					durationInMinutes: this.durationInMinutes,
					otherSamples: this.otherSamples,
					notes: this.visitNotes,
					objections: this.objection,
					nextVisitNotes: this.centerNotes,
					purpose: this.nextCall,
					// materialAmounts: this.samples[0].data.materialId === null ? [] : this.samples.map(c => c.data),
					materialAmounts: this.$refs.table ? this.samplesItems.map(c => ({
						amount: c.amount,
						freeSample: c.freeSample,
						materialId: c.materialId,
						priceDiscount: +c.priceDiscount,
						sellPrice: c.sellPrice,
						total: c.total
					})) : this.samples[0].data.materialId === null ? [] : this.samples.map(c => ({
						amount: c.data.amount,
						materialId: c.data.materialId,
						priceDiscount: c.data.priceDiscount,
						sellPrice: c.data.sellPrice,
						total: c.data.total,
					})),
					unavailableMaterialIds: this.unavailableMaterialIds,
					competitiveSamples: this.competitors.map(c => c.value),
					createdAt: this.create,
					residentDoctorNames: this.residentDoctorNames,
					amountReceived: this.amountReceived,
					priceTypeId: this.priceType,
					// التأكد من اسم البارامتر
					type: this.dirType
				})
					.then(() => {
						this.$eventBus.$emit('show-snackbar', 'Visit is created');
						this.$emit('on-save');
						this.dialog = false;
					}).catch((response) => {
						this.$eventBus.$emit('show-snackbar', response.response.data.message, 'error');
					})
					.finally(() => {
						this.loading = false;
					})
			} else {
				// edit visit
				this.$store.dispatch('mineVisits/update', {
					id: this.id,
					entityId: this.entityId,
					coreMessage: this.coreMessage,
					durationInMinutes: this.durationInMinutes,
					otherSamples: this.otherSamples,
					notes: this.visitNotes,
					objections: this.objection,
					nextVisitNotes: this.centerNotes,
					purpose: this.nextCall,
					materialAmounts: this.$refs.table ? this.samplesItems.map(c => ({
						amount: c.amount,
						freeSample: c.freeSample,
						materialId: c.materialId,
						priceDiscount: c.priceDiscount,
						sellPrice: c.sellPrice,
						total: c.total
					})) : this.samples[0].data.materialId === null ? [] : this.samples.map(c => ({
						amount: c.data.amount,
						materialId: c.data.materialId,
						priceDiscount: c.data.priceDiscount,
						sellPrice: c.data.sellPrice
					})),
					unavailableMaterialIds: this.unavailableMaterialIds,
					competitiveSamples: this.competitors.map(c => c.value),
					residentDoctorNames: this.residentDoctorNames,
					// "longitude": "string",
					// "latitude": "string",
					amountReceived: this.amountReceived,
					priceTypeId: this.priceType,
					payment: this.total === this.amountReceived ? 1 : 3,
				})
					.then(() => {
						this.$eventBus.$emit('show-snackbar', 'Visit is edited');
						this.$emit('on-save');
						this.dialog = false;
					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		
        getRegions() {
            this.regionsLoading = true
            this.$store.dispatch('regions/fetchAll', { cityId: this.cityId }).finally(() => {
                this.regionsLoading = false
            })
        },

		addItem () {
			if (this.$refs.table.validate()) {
				this.samplesItems.push({
					id: (Math.random()).toString(),
					...this.tableInputs,
					priceDiscount: +this.tableInputs.priceDiscount
				})
				this.$refs.table.resetInputs()
				this.amountReceived = this.samplesItems.length === 1
					? this.samplesItems[0].total
					: this.samplesItems.map(c => c.total).reduce((a, b) => a + b)
			}
		},

		editItem () {
			if (this.$refs.table.validate()) {
				this.samplesItems[this.editRowIndex].materialId = this.tableInputs.materialId
				this.samplesItems[this.editRowIndex].amount = this.tableInputs.amount
				this.samplesItems[this.editRowIndex].sellPrice = this.tableInputs.sellPrice
				this.samplesItems[this.editRowIndex].priceDiscount = this.tableInputs.priceDiscount !== null ? +this.tableInputs.priceDiscount : 0
				this.samplesItems[this.editRowIndex].total = this.tableInputs.total
				this.samplesItems[this.editRowIndex].freeSample = this.tableInputs.freeSample

				this.$refs.table.resetEdit();
				this.isEdit = false;
				this.$nextTick(() => {
					this.$refs.table.resetInputs();
					this.$refs.table.resetInputsFocus()
				})
			}
		},

		deleteItem (index) {
			this.samplesItems.splice(index, 1)
		},

		getPrice (sample) {
			if (this.addPrice) {
				if (this.$vuetify.breakpoint.mdAndUp) {
					const material = this.myMaterials.find(c => c.id === this.tableInputs.materialId)
					const mainType = this.priceType
   
					if (material?.prices.length && material?.prices.find(c => c.priceId === this.priceType)?.price > 0) {
					   this.tableInputs.sellPrice = material?.prices.find(c => c.priceId === mainType)?.price
				   	} else if (!material?.prices.length || (material?.prices.find(c => c.priceId === this.priceType)?.price === 0 || !material?.prices.find(c => c.priceId === this.priceType) || material?.prices.length < this.pricesTypes.length)) {
					   	// show dialog for adding material type price
					   	const obj = {
						   priceType: mainType,
						   materialId: material.id
					   	}
					   this.tableInputs.sellPrice = 0
					   this.$emit('on-open', obj)
				   	}
			   	} else {
					const material = this.myMaterials.find(c => c.id === sample.materialId)	
					if (
						!material.prices.length || 
						(
							!material?.prices.find(c => c.priceId === this.priceType) || 
							material?.prices.find(c => c.priceId === this.priceType)?.price === 0
						)
					) {
						const obj = {
							priceType: this.priceType,
							materialId: sample?.materialId,
							id: sample.id
						}
						this.$emit('on-open', obj)
					} else if (
						(
							material && 
							material?.prices.length !== 0
						) ||
						(
							material.prices.find(c => c.priceId === this.priceType)
						)
					) {
						this.samples.find(c => c.id === sample.id).data.sellPrice = material?.prices.find(c => c.priceId === this.priceType)?.price
					}
				}
			}
		},

		deleteRow(rowData) {
            this.$refs.table.resetEdit();
			this.isEdit = false;
			this.samplesItems.splice(rowData.index, 1);
			
			this.$nextTick(() => {
				this.$refs.table.resetInputs();
				this.$refs.table.resetInputsFocus()
			})
		},

		resetAllFieldAssociatedWithThePrice () {
			if (this.tableInputs.freeSample) {
				this.tableInputs.price = 0
				this.tableInputs.priceDiscount = 0
				this.tableInputs.total = 0
				this.tableInputs.sellPrice = 0
			} else {
				this.getPrice()
			}
		}
	},

	computed: {
		// getMaterialName() {
		// 	const arr = this.myMaterials.map(c => ({
		// 		...c,
		// 		name: this.getMaterialById(c.materialId)?.name,
		// 		id: this.getMaterialById(c.materialId)?.id,
		// 	})) 
		// 	return arr
		// },

		...mapState({
			regions: state => state.regions.regions,
			transactions: state => state.materialTransactions.transactions,
			materialForms: state => state.materialForms.materialForms,
			// entities: state => state.entities.entities,
			// entities: state => state.entities.entitiesBrief,
			cities: state => state.cities.cities,
			myMaterials: state => state.materials.myMaterials,
			pricesTypes: state => state.pricesTypes.pricesTypes,
			visits: state => state.visits.visits,
			customersTypes: state => state.entityType.customersTypes,
			visitsConfig: state => state.configuration.configurations.visitsConfig,
			regionsAll: state => state.regions.regionsAll
		}),

		...mapGetters({
			getRegionAllById: 'regions/getRegionAllById',
			getVisitById: 'mineVisits/getVisitById',
			getMaterialByName: 'materials/getMaterialByName',
			getMaterialById: 'materials/getMaterialById',
			getMaterialFormById: 'materialForms/getMaterialFormById'
		}),

		materials() {
			const availableMaterials = [];
			const availableMaterialsIds = this.transactions.map(c => c.materialId);
			availableMaterialsIds.forEach(id => availableMaterials.push(this.getMaterialById(id)))
			return availableMaterials;
		},

		headersSamples () {
			return [
				{
					text: this.$t('headers.item'),
					name: 'materialId',
					value: 'materialId',
					setValueExpr: val => this.myMaterials.find(c => c.id === val)?.name,
					inputRules: rules.required || [],
					sortable: false,
					width: '30%'
				},
				{
					text: this.$t('headers.amount'),
					name: 'amount',
					value: 'amount',
					type: 'number',
					inputRules: rules.requiredAsNumber || '',
					sortable: false
				},
				addPrice ? {
					text: this.$t('headers.free'),
					name: 'freeSample',
					value: 'freeSample',
					sortable: false
				} : null,
				addPrice ? {
					text: this.$t('headers.price'),
					name: 'sellPrice',
					value: 'sellPrice',
					disableInput: this.tableInputs.freeSample || !this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.priceType) || this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.priceType).price === 0,
					inputRules: this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.length && 
							this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.priceType)?.price !== 0 && 
                            this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.priceType)?.priceDiscount > 0 ? [val => {
                        const material = this.myMaterials.find(c => c.id === this.tableInputs.materialId)
                        const priceForPriceType = material.prices.find(c => c.priceId === this.priceType)?.price
                        const discount = material?.prices.find(c => c.priceId === this.priceType)?.priceDiscount / 100 
                        return (priceForPriceType - (priceForPriceType * discount)) <= Number(val) && priceForPriceType >= Number(val)
                    }] : [],
					type: 'number',
					sortable: false,
					width: '15%'
				} : null,
				addPrice ? {
					text: this.$t('headers.discount'),
					name: 'priceDiscount',
					value: 'priceDiscount',
					inputRules: [val => val <= (this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.priceType)?.priceDiscount) || val === 0],
					type: 'number',
					sortable: false,
					disableInput: this.tableInputs.freeSample,
				} : null,
				addPrice ? {
					text: this.$t('headers.total'),
					name: 'total',
					value: 'total',
					disableInput: true,
					setInputExpr: inputs => {
						if (!inputs.freeSample) {
							return inputs.priceDiscount ? (inputs.amount * inputs.sellPrice) : (inputs.amount * inputs.sellPrice)
						} else {
							return 0
						}
					},
					width: '15%',
					sortable: false
				} : null,
				{
					text: '',
					name: 'action',
					value: 'action',
					noInput: true,
					sortable: false
				}
			].filter(c => c !== null)
		},

		total () {
			let total = null
			if (this.$vuetify.breakpoint.mdAndUp) {
				total = this.samplesItems.length === 1 ? this.samplesItems[0].total : this.samplesItems.map(c => c.total).reduce((a, b) => a + b)
			} else {
				total = this.samples.length === 1 ? this.samples[0].data.total : this.samples.map(c => c.data.total).reduce((a, b) => a + b)
			}
			return total						
		}
	}
}
</script>

<style>

</style>